import React from 'react';
import { TextInput as BaseTextInput } from 'evergreen-ui';
import cn from 'classnames';

import styles from './styles.module.scss';

// TODO: describe used props
const TextInput = ({ label, ...props }) => (
  <div className={styles.inputWrapper}>
    {label && (
      <div className={styles.label}>{label}</div>
    )}
    {/* could not find a pure css approach to change placeholder color */}
    <BaseTextInput
      {...props}
      className={
        cn(
          styles.input,
          props.className,
          (!props.value && !props.defaultValue) ? styles.placeholder : undefined,
        )
      }
    />
  </div>
);

export default TextInput;
